import React, { useEffect, useState } from "react";
import { RiErrorWarningLine } from "react-icons/ri";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import parse from "html-react-parser";
import axios from "axios";
import {
  Pagination,
  Skeleton,
  Stack,
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import { Modal } from "react-bootstrap";
import {
  BaseUrl,
  emailservice,
  newBaseUrlLang,
} from "../../container/BaseUrl/BaseUrl";
import facebook from "../../assets/assets/images/facebook.png";
import whatsapp from "../../assets/assets/images/whatsapp.png";
import webchat from "../../assets/assets/images/chat-icon.png";
import twitter from "../../assets/assets/images/twitter.png";
import email from "../../assets/assets/images/email.png";
import voice from "../../assets/assets/images/voice.png";
import { useNavigate } from "react-router-dom";

import {
  setPullContact,
  setChatRefresh,
  setsidebarVal,
  GetAllUsers,
  setValue,
} from "../../redux/actions/actions";

import { connect } from "react-redux";
import { toast } from "react-toastify";
import { FunnelSimple } from "@phosphor-icons/react";
import { AiOutlineCloseCircle } from "react-icons/ai";
import moment from "moment";

const mapStateToProps = (state) => {
  return {
    pullcontact: state.data.pullcontact,
  };
};

const MultimediaSearch = (props) => {
  const navigate = useNavigate();
  const [chatmodal, setChatmodal] = useState(false);
  const [sessionvalueforemail, setSessionvalforemail] = useState([]);
  const [basedonchannel, setBasedonchannel] = useState("");
  const [skilldropdown, setSkilldropdown] = useState([]);
  const [agentlist, setAgentlist] = useState([]);

  const basedOnRole = JSON.parse(localStorage.getItem("tokenAgent"));
  var someDate = new Date();
  var date = someDate.setDate(someDate.getDate());
  var defaultValue = new Date(date).toISOString().split("T")[0];

  const isToDateValid = () => {
    return new Date(todate) >= new Date(fromdate);
  };

  let agentRole = JSON.parse(localStorage.getItem("tokenAgent"));
  const [showfilter, setshowfilter] = useState("sidebar_filter");
  const [mediaSearchDatas, setMediaSearchDatas] = useState([]);
  const [fromdate, setFromdate] = useState(defaultValue);
  const [todate, setTodate] = useState(defaultValue);
  const [name, setName] = useState("");
  const [emails, setEmail] = useState("");
  const [toemail, setToEmail] = useState("");
  const [searchbysubject, setsearchBySubject] = useState("");
  const [searchbybody, setsearchByBody] = useState("");
  const [channel, setChannel] = useState("");
  const [status, setStatus] = useState("");
  const [agent, seAagent] = useState("");

  const [skillSet, setSkillset] = useState("");
  const [pagination, setPagination] = useState(0);
  const [page, setPage] = useState(1);
  const [loadingMultimedia, setloadingMultimedia] = useState(false);

  const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.common.black,
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.black,
    },
  }));

  const multiMediaSearch = () => {
    setloadingMultimedia(true);
    const requestData = {
      customerName: name ? name : "",
      email: emails ? emails : "",
      toemail: toemail ? toemail : "",
      fromDate: fromdate ? fromdate : defaultValue,
      toDate: todate ? todate : defaultValue,
      category: skillSet ? skillSet : "",
      limit: 10,
      offset: page == 1 ? 0 : (page - 1) * 10,
      subject: searchbysubject ? searchbysubject : "",
      email_body: searchbybody ? searchbybody : "",
      agent: agentRole.role == "Supervisor" ? agent : "",
      channel: channel,
      status: status,
    };

    const headers = {
      "Content-Type": "application/json",
      Tenantid: localStorage.getItem("TenantId"),
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    };

    axios
      .post(BaseUrl + "/reports/multiMediaSearch", requestData, { headers })
      .then((response) => {
        console.log("multiMediaSearch", response);
        if (response.data.status == true) {
          setMediaSearchDatas(response.data.Data);
          setPagination(response.data.count);
          setTimeout(() => {
            setloadingMultimedia(false);
          }, 1000);
        } else {
          toast.warn("No Data Found", {
            position: "top-right",
            autoClose: 500,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: "light",
          });
          setMediaSearchDatas([]);
          setTimeout(() => {
            setloadingMultimedia(false);
          }, 1000);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const PullContactApi = async (item) => {
    const tokenAgentValue = JSON.parse(localStorage.getItem("tokenAgent"));
    const requestData = {
      chat_session_id: item.chat_session_id,
      agent_id: tokenAgentValue.agent_id,
      user_id: tokenAgentValue.user_id,
    };

    const headers = {
      "Content-Type": "application/json",
      Tenantid: localStorage.getItem("TenantId"),
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    };

    await axios
      .post(BaseUrl + "/email/emailpullcontact", requestData, { headers })
      .then((response) => {
        if (response.status) {
          toast.success("Email Pull Successfully", {
            position: "top-right",
            autoClose: 500,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: "light",
          });
          props.setsidebarVal("Chat");
          navigate("/main/Chat");
          props.GetAllUsers();
          props.setValue(0);
        } else {
          setPullContact(false);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const handlechatClose = () => setChatmodal(false);

  useEffect(() => {
    multiMediaSearch();
  }, [page]);

  const handleChange = (event, value) => {
    setPage(value);
  };

  useEffect(() => {
    skillsetDropdown();
    if (basedOnRole.role == "Supervisor") {
      agentListdropdown();
    }
  }, []);

  const skillsetDropdown = () => {
    let data = {
      enabled: true,
    };
    axios
      .post(newBaseUrlLang + "usermodule/clientMaster/skills/list", data, {
        headers: {
          tenantId: localStorage.getItem("TenantId"),
        },
      })
      .then((res) => {
        console.log("res");
        setSkilldropdown(res.data.dataList);
      })
      .catch((error) => {});
  };

  const agentListdropdown = async () => {
    await axios
      .post(
        BaseUrl + "/users/listagentList",
        {
          user_id: basedOnRole.user_id,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        setAgentlist(res.data.data);
      })
      .catch((err) => {
        setShow(true);
      });
  };

  const getSessionsDetailsForEmail = async (value) => {
    await axios
      .post(
        emailservice + "email/fetchEmailSummary",
        {
          ticketID: value.ticketID,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.Data) {
          setSessionvalforemail(res.data.Data);
          setChatmodal(true);
        } else {
          setSessionvalforemail([]);
          setChatmodal(false);
        }
      })
      .catch((err) => {
        setChatmodal(false);
      });
  };

  return (
    <>
      <div className="sessiontable" style={{ overflow: "hidden" }}>
        <header className="header_role ">
          <div className="conatiner-fluid">
            <nav
              className="navbar "
              style={{ paddingTop: "0px", paddingBottom: "0px" }}
            >
              <div className="container-fluid p-0">
                <div className="hed_left d-flex"></div>
                <div className="hed_right d-flex ">
                  <Stack direction={"row"} spacing={1} alignItems={"center"}>
                    <Button
                      size="small"
                      variant="contained"
                      endIcon={<FunnelSimple size={18} weight="bold" />}
                      onClick={() => {
                        setshowfilter("sidebar_filter active-r");
                      }}
                    >
                      Filter
                    </Button>
                  </Stack>
                </div>
              </div>
            </nav>
          </div>
        </header>

        <div className="multimediatable container-fluid">
          <div className="card fixed-table-card vh-79 multimediacard">
            <div className="card-body agentContactbody">
              <div className="table-responsive vhm-68">
                <table className="table table-sm table-hover align-middle table-fixeded">
                  <thead>
                    <tr>
                      <th scope="col">Customer Name</th>
                      <th scope="col">Phone Number</th>
                      <th scope="col">Email</th>
                      <th scope="col">Channel</th>
                      <th scope="col">Status</th>
                      <th scope="col">Subject</th>
                      <th scope="col">Skillset</th>
                      <th scope="col">Language</th>
                      <th scope="col">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loadingMultimedia ? (
                      [...Array(8)].map((_, rowIndex) => (
                        <tr key={rowIndex}>
                          {[...Array(9)].map((_, colIndex) => (
                            <td key={colIndex}>
                              <Skeleton variant="text" width={90} height={30} />
                            </td>
                          ))}
                        </tr>
                      ))
                    ) : Array.isArray(mediaSearchDatas) &&
                      mediaSearchDatas.length > 0 ? (
                      mediaSearchDatas.map((rowData, rowIndex) => (
                        <tr key={rowIndex._id} className="text-break">
                          <td>
                            {rowData.unique_id
                              ? rowData.unique_id.username
                              : ""}
                          </td>
                          <td>
                            {rowData.unique_id
                              ? rowData.unique_id.phonenumber
                              : ""}
                          </td>
                          <td>
                            {rowData.unique_id ? rowData.unique_id.email : ""}
                          </td>
                          <td>
                            {rowData.channel == "webchat" ? (
                              <img
                                width="30px"
                                height="30px"
                                src={webchat}
                                alt="webchat"
                              />
                            ) : rowData.channel == "from_whatsapp" ? (
                              <img
                                width="30px"
                                height="30px"
                                src={whatsapp}
                                alt="webchat"
                              />
                            ) : rowData.channel == "from_twitter" ? (
                              <img
                                width="30px"
                                height="30px"
                                src={twitter}
                                alt="webchat"
                              />
                            ) : rowData.channel == "voice" ? (
                              <img
                                width="30px"
                                height="30px"
                                src={voice}
                                alt="webchat"
                              />
                            ) : rowData.channel == "from_facebook" ? (
                              (
                                <img
                                  width="30px"
                                  height="30px"
                                  src={facebook}
                                  alt="webchat"
                                />
                              ) || rowData.channel == "from_teams"
                            ) : (
                              <img
                                width="30px"
                                height="30px"
                                src={email}
                                alt="webchat"
                              />
                            )}
                          </td>
                          <td>
                            {rowData.status == "chatEnded"
                              ? "Completed"
                              : rowData.status == "newjoin"
                              ? "Presented"
                              : rowData.status == "Accept"
                              ? "Active"
                              : rowData.status}
                          </td>
                          <td>{"subject will come"}</td>
                          <td>{rowData.skillset}</td>
                          <td>{rowData.language}</td>
                          <td>
                            <div>
                              <Stack direction="row" spacing={0.5}>
                                {rowData.channel == "email" &&
                                rowData.status !== "Accept" ? (
                                  <>
                                    <BootstrapTooltip
                                      title={"Pull"}
                                      arrow
                                      placement="top"
                                    >
                                      <button
                                        type="button"
                                        className="btn btn-primary"
                                        id="contact-mail"
                                        onClick={() => {
                                          PullContactApi(rowData);
                                        }}
                                      >
                                        <i
                                          className="fa-solid fa-code-pull-request fa-xs"
                                          color="blue"
                                        ></i>
                                      </button>
                                    </BootstrapTooltip>
                                    <BootstrapTooltip
                                      title="Preview"
                                      arrow
                                      placement="top"
                                    >
                                      <button
                                        type="button"
                                        className="btn btn-primary"
                                        id="contact-mail"
                                        onClick={() => {
                                          getSessionsDetailsForEmail(rowData);
                                        }}
                                      >
                                        <i class="fa-regular fa-eye fa-xs"></i>
                                      </button>
                                    </BootstrapTooltip>
                                  </>
                                ) : rowData.channel == "email" ? (
                                  <BootstrapTooltip
                                    title="Preview"
                                    arrow
                                    placement="top"
                                  >
                                    <button
                                      type="button"
                                      className="btn btn-primary"
                                      id="contact-mail"
                                      onClick={() => {
                                        getSessionsDetailsForEmail(rowData);
                                      }}
                                    >
                                      <i class="fa-regular fa-eye fa-xs"></i>
                                    </button>
                                  </BootstrapTooltip>
                                ) : null}
                              </Stack>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="15">
                          <div
                            className="text-muted"
                            style={{
                              flexDirection: "column",
                              marginTop: "20%",
                              display: "flex",
                              position: "absolute",
                              left: "45%",

                              top: "-10%",
                            }}
                          >
                            <span className="mx-auto">
                              <RiErrorWarningLine size={30} />
                            </span>
                            <span className="mx-auto">
                              <h5
                                className="text-muted mt-2"
                                style={{ fontFamily: "poppins" }}
                              >
                                {Array.isArray(mediaSearchDatas)
                                  ? "No Data Found"
                                  : "No Data Found"}
                              </h5>
                            </span>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="card-footer rounded-0 d-flex justify-content-between">
              <div>
                Showing {Math.min((page - 1) * 10 + 1, pagination)} to{" "}
                {Math.min(page * 10, pagination)} of {pagination} entries
              </div>
              <Pagination
                count={Math.ceil(pagination / 10)}
                page={page}
                color="primary"
                size="small"
                style={{ float: "right" }}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>

        <nav className={showfilter} style={{ top: "0px" }}>
          <div className="filter col-md-12 shadow p-4 ">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <p className="mb-0">Filters</p>
              <div className="dismiss ">
                <span
                  id="session_filter_close_btn"
                  className="material-symbols-outlined"
                  onClick={() => {
                    setshowfilter("sidebar_filter");
                  }}
                >
                  cancel
                </span>
              </div>
            </div>

            <div className="filter_form">
              <form className=" fillter_form2 " style={{ height: "75vh" }}>
                <div className="custom_div">
                  {basedOnRole.role == "Supervisor" ? (
                    <div className="mb-3 d-flex flex-column text-start">
                      <label htmlFor="Select" className="form-label">
                        Agent
                      </label>
                      <select
                        className="form-select form-select-sm"
                        aria-label="Default select example"
                        onChange={(e) => seAagent(e.target.value)}
                      >
                        <option value="">Select Agent</option>
                        <option value="">Select All</option>

                        {agentlist.length > 0
                          ? agentlist.map((item) => {
                              return (
                                <>
                                  <option value={item.id}>
                                    {item.username}
                                  </option>
                                </>
                              );
                            })
                          : ""}
                      </select>
                    </div>
                  ) : (
                    ""
                  )}

                  <div
                    className="mb-3 d-flex flex-column text-start"
                    style={{ fontSize: "13px" }}
                  >
                    <label>Name</label>
                    <input
                      type="text"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      className="form-control form-select-sm"
                    />
                  </div>
                  <div
                    className="mb-3 d-flex flex-column text-start"
                    style={{ fontSize: "13px" }}
                  >
                    <label>From Email</label>
                    <input
                      type="text"
                      onChange={(e) => setEmail(e.target.value)}
                      className="form-control form-select-sm"
                    />
                  </div>
                  <div
                    className="mb-3 d-flex flex-column text-start"
                    style={{ fontSize: "13px" }}
                  >
                    <label>To Email</label>
                    <input
                      type="text"
                      value={toemail}
                      onChange={(e) => setToEmail(e.target.value)}
                      className="form-control form-select-sm"
                    />
                  </div>

                  <div className="mb-3 d-flex flex-column text-start">
                    <label htmlFor="fromdate" className="form-label">
                      From
                    </label>
                    <input
                      type="date"
                      className="form-control form-select-sm"
                      id=""
                      aria-describedby="date"
                      value={fromdate}
                      onChange={(e) => setFromdate(e.target.value)}
                      max={defaultValue}
                    />
                  </div>
                  <div className="mb-3 d-flex flex-column text-start">
                    <label htmlFor="todate" className="form-label">
                      To
                    </label>
                    <input
                      type="date"
                      className="form-control form-select-sm"
                      id=""
                      aria-describedby="date"
                      value={todate}
                      onChange={(e) => setTodate(e.target.value)}
                      max={defaultValue}
                    />
                    {!isToDateValid() && (
                      <span
                        className="text-danger fw-bold"
                        style={{ fontSize: "10px" }}
                      >
                        To Date cannot be less than From Date*
                      </span>
                    )}
                  </div>
                </div>

                <div className="mb-3 d-flex flex-column text-start">
                  <label htmlFor="Select" className="form-label">
                    Channel
                  </label>
                  <select
                    className="form-select form-select-sm"
                    aria-label="Default select example"
                    onChange={(e) => {
                      setBasedonchannel(e.target.value);
                      setChannel(e.target.value);
                    }}
                  >
                    <option value="">Select Channel</option>
                    <option value="webchat">Webchat</option>
                    <option value="email">Email</option>
                    <option value="voice">Voice</option>
                    <option value="from_whatsapp">Whatsapp</option>
                  </select>
                </div>

                <div className="mb-3 d-flex flex-column text-start">
                  <label htmlFor="Select" className="form-label">
                    Skillset
                  </label>
                  <select
                    className="form-select form-select-sm"
                    aria-label="Default select example"
                    onChange={(e) => setSkillset(e.target.value)}
                  >
                    <option value="">Select Skillset</option>
                    <option value="">Select All</option>
                    {skilldropdown.map((item) => {
                      return (
                        <>
                          <option value={item.skillName}>
                            {item.skillName}
                          </option>
                        </>
                      );
                    })}
                  </select>
                </div>

                <div className="mb-3 d-flex flex-column text-start">
                  <label htmlFor="Select" className="form-label">
                    Status
                  </label>
                  <select
                    className="form-select form-select-sm"
                    aria-label="Default select example"
                    onChange={(e) => setStatus(e.target.value)}
                  >
                    <option value="">Select Status</option>
                    <option value="Accept">Active</option>
                    <option value="chatEnded"> Completed</option>
                    <option value="newjoin"> Presented</option>
                    <option value="Queued"> Queued</option>
                    {basedonchannel == "webchat" ? (
                      <option value="CustomerDropped"> CustomerDropped</option>
                    ) : (
                      ""
                    )}
                  </select>
                </div>

                {basedonchannel == "email" ? (
                  <div className="mb-3 d-flex flex-column text-start">
                    <label htmlFor="Select" className="form-label">
                      Search
                    </label>

                    <div className="mt-2 d-flex flex-column text-start">
                      <input
                        type="text"
                        onChange={(e) => {
                          setsearchBySubject(e.target.value);
                        }}
                        className="form-control form-control-sm"
                        placeholder="Enter Subject..."
                      />
                    </div>

                    <div className="mt-2 d-flex flex-column text-start">
                      <input
                        type="text"
                        onChange={(e) => setsearchByBody(e.target.value)}
                        className="form-control form-control-sm"
                        placeholder="Search By Keywords..."
                      />
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </form>
              <div className="filter_submit">
                <div className="d-flex">
                  <div className="col-md-12 ps-2">
                    <button
                      type="button"
                      id="session_filter_Submit"
                      className="btn btn-primary w-100 text-white"
                      onClick={() => {
                        if (isToDateValid()) {
                          setPage(1);
                          multiMediaSearch();
                          setshowfilter("sidebar_filter");
                        }
                      }}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </div>

      <Modal
        size="md"
        show={chatmodal}
        onHide={handlechatClose}
        style={{ outline: "none", overflow: "hidden" }}
        className="interaction_modal"
        centered
      >
        <Modal.Header
          style={{
            backgroundColor: "#0b3363",
            color: "#fff",
            height: "30px",
          }}
        >
          <Modal.Title
            id="example-modal-sizes-title-md"
            style={{ color: "#fff", fontSize: "16px" }}
          >
            Interaction Preview
          </Modal.Title>

          <Modal.Title>
            <AiOutlineCloseCircle
              size={20}
              style={{ color: "#fff", cursor: "pointer" }}
              onClick={handlechatClose}
            />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          className="custom-scroll"
          style={{
            overflowY: "auto",
            height: "24rem",
          }}
        >
          <div className="">
            {sessionvalueforemail.map((item) => {
              return (
                <div className="w-100">
                  <div className="user-chat-main d-flex flex-column ">
                    <div className="p-1 h-75">
                      <div style={{ width: "100%" }}>
                        <div className="email-desc-wrapper">
                          <div className="title-subject">
                            <h5>{item.Email.subject}</h5>
                          </div>
                          <Accordion
                            style={{
                              marginTop: "15px",
                            }}
                          >
                            <AccordionSummary
                              aria-controls="panel1a-content"
                              id="panel1a-header"
                            >
                              <Typography>
                                <div className="email-header d-flex w-100">
                                  <div className="address mx-2 my-2 ">
                                    <p className="recipient" id="from"></p>
                                    <p className="recipient fs-6" id="to">
                                      <span>
                                        To:
                                        {item.Email.toList}
                                      </span>
                                    </p>
                                    {item.Email.ccList ? (
                                      <p className="recipient fs-6" id="cc">
                                        <span>
                                          Cc:
                                          {item.Email.ccList}
                                        </span>
                                      </p>
                                    ) : null}
                                    <p className="recipient fs-6" id="date">
                                      <span>
                                        {moment(item.Email.receivedTime).format(
                                          "MMMM Do YYYY, h:mm A"
                                        )}
                                      </span>
                                    </p>
                                  </div>
                                </div>
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              {!_.isEmpty(item.Email.attachments) ? (
                                <>
                                  <Grid container spacing={1}>
                                    {_.map(
                                      _.filter(item.Email.attachments, {
                                        location: "attachment",
                                      }),
                                      (val, i) => {
                                        if (
                                          imageFormat.includes(val.extension)
                                        ) {
                                          return (
                                            <Grid item xs={3} key={i}>
                                              <div
                                                className="attachment_container"
                                                onClick={(e) =>
                                                  openActionView(e, val)
                                                }
                                              >
                                                <img
                                                  src={val.url}
                                                  alt="Avatar"
                                                  className="image_attachment"
                                                />
                                                <div className="attachment_overlay">
                                                  <div className="attachment_text">
                                                    {val.filename}
                                                  </div>
                                                </div>
                                              </div>
                                            </Grid>
                                          );
                                        }
                                        return null;
                                      }
                                    )}
                                  </Grid>

                                  <Grid container spacing={1}>
                                    {_.map(
                                      _.filter(item.Email.attachments, {
                                        location: "attachment",
                                      }),
                                      (val, i) => {
                                        if (
                                          !imageFormat.includes(val.extension)
                                        ) {
                                          return (
                                            <Grid item xl={2} key={i}>
                                              <Paper>
                                                <MenuItem>
                                                  <ListItemIcon className="attachment_Preview_image">
                                                    <img
                                                      src={getIcon(
                                                        val.extension
                                                      )}
                                                      height="20px"
                                                      weight="20px"
                                                      alt="Icon"
                                                    />
                                                  </ListItemIcon>
                                                  <ListItemText>
                                                    <span className="attachment_el_text">
                                                      {val.filename}
                                                    </span>
                                                  </ListItemText>
                                                  <Typography
                                                    variant="body2"
                                                    color="text.secondary"
                                                  >
                                                    <IconButton
                                                      onClick={(e) =>
                                                        openActionView(e, val)
                                                      }
                                                    >
                                                      <ExpandMoreIcon />
                                                    </IconButton>
                                                  </Typography>
                                                </MenuItem>
                                              </Paper>
                                            </Grid>
                                          );
                                        }
                                        return null;
                                      }
                                    )}
                                  </Grid>
                                </>
                              ) : (
                                ""
                              )}
                              <Typography>
                                <div className="mailcontent">
                                  <div className="email-body">
                                    {item.EmailBody
                                      ? parse(
                                          item.EmailBody.replace(
                                            /\s+/g,
                                            " "
                                          ).trim()
                                        )
                                      : ""}
                                  </div>
                                </div>
                              </Typography>
                            </AccordionDetails>
                          </Accordion>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default connect(mapStateToProps, {
  setPullContact,
  setChatRefresh,
  setsidebarVal,
  GetAllUsers,
  setValue,
})(MultimediaSearch);
